'use strict';

$ = jQuery;

/*
* Evento de clique em notícias
*/
$('.jc-catalog-news a').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Notícias',
    'eventLabel': $(this).parents('.jc-catalog-news').find('.jc-catalog-news-title').text()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Notícias',
    'eventLabel': $(this).parents('.jc-catalog-news').find('.jc-catalog-news-title').text()
  });
});